import { INoteFile } from '@/contracts/modules/note/entities/INoteFile'

export class NoteFile implements INoteFile {
  constructor(
    private uuid: string,
    private name: string,
    private path: string,
    private size: number,
    private mime: string,
    private readable: boolean,
  ) {}

  /** Файл, чей ключ или сведения не прочитались: виден по UUID, без имени */
  static unreadable(uuid: string, size: number): NoteFile {
    return new NoteFile(uuid, uuid, uuid, size, '', false)
  }

  getUuid(): string {
    return this.uuid
  }

  getName(): string {
    return this.name
  }

  getPath(): string {
    return this.path
  }

  getSize(): number {
    return this.size
  }

  getMime(): string {
    return this.mime
  }

  isReadable(): boolean {
    return this.readable
  }
}
